import React, { useEffect } from 'react';
import { LoginForm, Spinner } from 'components';
import { fulfilled, pending, clean } from 'redux-saga-thunk';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { transvoiceResourceAuthenticate } from 'store/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import generateHashPassword from 'utils/hashUtil';

export function Login({
  authenticateResourceUser = () => {},
  isAuthenticationFulfilled = false,
  isAuthenticationPending = false,
  cleanAuthentication = () => {},
}) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isUserLoginFromEmailLink = params.get('data');
    if (isUserLoginFromEmailLink) {
      navigate('/forgot-password', {
        state: { data: location.search.split('=')[1] },
      });
    }
  }, []);

  useEffect(() => {
    if (isAuthenticationFulfilled) {
      cleanAuthentication();

      navigate('/', {
        state: { showWelcomeModal: true },
      });
    }
  }, [isAuthenticationFulfilled]);

  const handleFormSubmit = ({ password, email }) => {
    const data = {
      email,
      passwordHash: generateHashPassword(password),
      isRefresh: false,
    };
    authenticateResourceUser(data);
  };

  return (
    <>
      {isAuthenticationPending && <Spinner />}
      <LoginForm onFormSubmit={handleFormSubmit} />
    </>
  );
}

Login.propTypes = {
  authenticateResourceUser: PropTypes.func,
  cleanAuthentication: PropTypes.func,
  location: PropTypes.shape({ search: PropTypes.string }),
  isAuthenticationFulfilled: PropTypes.bool,
  isAuthenticationPending: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  authenticateResourceUser: data =>
    dispatch(transvoiceResourceAuthenticate(data)),
  cleanAuthentication: () => {
    dispatch(clean('resourceUserAuthenticate'));
  },
});
const mapStateToProps = state => ({
  isAuthenticationFulfilled: fulfilled(state, 'resourceUserAuthenticate'),
  isAuthenticationPending: pending(state, 'resourceUserAuthenticate'),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
